// extracted by mini-css-extract-plugin
export default {"title":"ResponseModal_title__YyzQo","content":"ResponseModal_content__J37PV","buttonText":"ResponseModal_buttonText__b0P7E","humed":"ResponseModal_humed__QvoJE"};